import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFieldsModule } from '@boldpenguin/emperor-form-fields';
import { IconsModule } from '@boldpenguin/emperor-icons';
import {
  EmperorButtonModule,
  EmperorCardModule,
} from '@boldpenguin/emperor-presentational';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthDashboardComponent } from './components/auth-dashboard/auth-dashboard.component';
import { AuthDashboardLeftSideComponent } from './components/auth-dashboard/dashboard-left-side/dashboard-left-side.component';
import { LoggedOutComponent } from './components/logged-out/logged-out.component';
import { LoginComponent } from './components/login/login.component';
import { SamlLoginComponent } from './components/saml-login/saml-login.component';

@NgModule({
  declarations: [
    AuthDashboardComponent,
    AuthDashboardLeftSideComponent,
    LoggedOutComponent,
    LoginComponent,
    SamlLoginComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    AuthRoutingModule,
    FormFieldsModule,
    EmperorCardModule,
    EmperorButtonModule,
    IconsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', hideRequiredMarker: true },
    },
  ],
})
export class AuthModule {}
